import { render, staticRenderFns } from "./deleteBin.vue?vue&type=template&id=2a5ffc2a&"
import script from "./deleteBin.vue?vue&type=script&lang=js&"
export * from "./deleteBin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports